'use strict';

var defaults = require('../defaults/Defaults');
var FirebaseIndirectArray = require('./FirebaseIndirectArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeCall = require('./KayleeCall');
var KayleeUtil = require('./KayleeUtil');
var log = require('../log/Log').channel('KayleeCalls');

var callType = require('./CallType');

var KayleeCalls = {
    callTypes: callType.callTypes,
    fromJson: fromJson,
    getCallClass: getCallClass,
    getCalls: getCalls,
};

function fromJson(data) {
    var reqProps = [ '$roomId' ];
    return FirebaseIndirectArray.$fromJson(data, 'Calls', reqProps, reqProps,
        function(data) {
            var room = KayleeCache.get('Room: ' + data.$roomId);
            return getCalls(room, data.$limit);
        }
    );
}

function getCallClass(callType) {
    if (callType === 'googleMeet' || callType === 'teams' || callType === 'video' || callType === 'zoom') return 'video';
    return 'audio';
}

function getCalls(room, limit) {
    var key = 'Calls: ' + room.$id;

    if (typeof limit !== 'undefined') {
        key += ' (' + limit + ')';
    }

    if (limit !== defaults.inara.numRecentCalls) {
        log.warning('getCalls: limit = ' + limit + ' instead of defaults.inara.numRecentCalls');
    }

    var calls = KayleeCache.get(key);

    if (calls === null) {
        calls = new Calls(room, limit);
        KayleeCache.put(key, calls);
    }

    return calls;
}

function Calls(room, limit) {
    var srcRef;

    this.$nodeType = 'calls';
    this.$room = room;
    this.$limit = limit;

    if (typeof limit === 'undefined') {
        srcRef = KayleeBase.app.database()
            .ref('index/callsByRoom/' + room.$id);
    } else {
        srcRef = KayleeBase.app.database()
            .ref('index/callsByRoom/' + room.$id)
            .orderByKey().limitToLast(limit);

        // Firebase doesn't seem to notify the cancel callback in FirebaseIndirectArray when we
        // add orderByKey and/or limitToLast to our reference. This causes the calls to not get
        // removed from the cache, which in turn causes issues with offline mode on Inara. To work
        // around this, we manually destroy ourselves when the room gets destroyed.

        var self = this;

        room.$onDestroy(function() {
            self.$destroy();
        });
    }

    FirebaseIndirectArray.call(this, srcRef, KayleeCall.getCall);
    KayleeUtil.bindPrototypeMethods(Calls.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

Calls.prototype = Object.create(FirebaseIndirectArray.prototype);
Calls.prototype.constructor = Calls;

Calls.prototype.$toJson = function() {
    return FirebaseIndirectArray.prototype.$toJson.call(this,
        [ '$limit' ], { $roomId: this.$room.$id });
};

Calls.prototype.$addNewCallWhileWorkingOffline = function(info) {
    var obj = {};

    KayleeCall.callProps.forEach(function(prop) {
        if (typeof info[prop] !== 'undefined' && info[prop] !== null) {
            obj[prop] = info[prop];
        }
    });

    if (!obj.hasOwnProperty('companyId')) obj.companyId = this.$room.companyId;
    if (!obj.hasOwnProperty('siteId')) obj.siteId = this.$room.siteId;
    if (!obj.hasOwnProperty('roomId')) obj.roomId = this.$room.$id;

    return this.$add(obj, info.callId);
};

Calls.prototype.toString = function() {
    return '[Calls for ' + this.$room + ']';
};

module.exports = KayleeCalls;
